import { useTranslation } from "react-i18next";

function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const lng = i18n.resolvedLanguage || i18n.language || "en";
  const isSk = lng.startsWith("sk");

  return (
    <div
      role="group"
      aria-label={t("lang.switcherAria")}
      className="inline-flex shrink-0 items-center rounded-full border-2 border-mainDark p-0.5"
    >
      <button
        type="button"
        onClick={() => i18n.changeLanguage("en")}
        className={`flex h-8 min-w-[2.25rem] items-center justify-center rounded-full px-2 text-xs font-semibold uppercase leading-none tracking-wide transition-colors duration-200 ${
          !isSk
            ? "bg-mainBlue text-onPrimary"
            : "text-mainDark hover:text-mainBlue"
        }`}
        aria-pressed={!isSk}
        lang="en"
      >
        {t("lang.enShort")}
      </button>
      <button
        type="button"
        onClick={() => i18n.changeLanguage("sk")}
        className={`flex h-8 min-w-[2.25rem] items-center justify-center rounded-full px-2 text-xs font-semibold uppercase leading-none tracking-wide transition-colors duration-200 ${
          isSk
            ? "bg-mainBlue text-onPrimary"
            : "text-mainDark hover:text-mainBlue"
        }`}
        aria-pressed={isSk}
        lang="sk"
      >
        {t("lang.skShort")}
      </button>
    </div>
  );
}

export default LanguageSwitcher;
